export default __webpack_public_path__ + "static/media/left-banner.9799cdb2.png";